import React from 'react';
import EventEmitter from 'events';

import util from '../tools/util';
import UserStore from './user_store';

export default {
  once,
  addChangeListener,
  removeChangeListener,
  init,
  isReady,
  getUsage,
  useUsage,
  fetch,
};

const g_usageVolumeMap = new Map<number, any>();

const g_eventEmitter = new EventEmitter();
const CHANGE_EVENT = 'change';
function once(callback) {
  g_eventEmitter.once(CHANGE_EVENT, callback);
}
function addChangeListener(callback) {
  g_eventEmitter.on(CHANGE_EVENT, callback);
}
function removeChangeListener(callback) {
  g_eventEmitter.removeListener(CHANGE_EVENT, callback);
}
function _emit(...args) {
  g_eventEmitter.emit(CHANGE_EVENT, ...args);
}
function init(done) {
  done?.();
}
function isReady() {
  return true;
}
function getUsage(volume_id: number) {
  return g_usageVolumeMap.get(volume_id);
}
function _subscribe(callback: any) {
  addChangeListener(callback);
  return () => {
    removeChangeListener(callback);
  };
}
export function useUsage(volume_id: number) {
  const _get = React.useCallback(() => getUsage(volume_id), [volume_id]);
  return React.useSyncExternalStore(_subscribe, _get);
}
function fetch(params: any, done?: (err?: any) => void) {
  const { org_id, volume_id } = params;
  const opts = { url: `/api/1/org/${org_id}/volume/${volume_id}/usage` };
  UserStore.get(opts, (err, body) => {
    if (err) {
      util.errorLog('UsageStore.fetch: err:', err);
    } else if (body) {
      body.s3_list?.forEach?.(_fixupUsage);
      body.usage_list?.forEach?.(_fixupUsage);
      const old = g_usageVolumeMap.get(volume_id);
      if (!util.deepEqual(old, body)) {
        g_usageVolumeMap.set(volume_id, body);
        _emit('update');
      }
    }
    done?.(err);
  });
}
function _fixupUsage(item) {
  item.usage_date = Date.parse(item.usage_date);
}
